module.exports = __webpack_public_path__ + "static/textFilter-180a0cde01d2ce6f3cd74afde5aa1587.gif";